import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/App';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ThemeProvider } from '@/theme/theme';
import { ToastProvider, Toaster } from '@/components/ui/toast';
import { initObservability } from '@/observability/monitoring';
import './styles.css';

const APP_BUILD_VERSION = '2026-02-07-cache-bust-2';

document.documentElement.setAttribute('data-app-build', APP_BUILD_VERSION);

initObservability();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
        <Toaster />
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>
);
